import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import styles from './style.module.scss';
import EnvIndicatorList from '@components-clean/navbar/env-indicator/env-indicator-list';
import { useBoolean, useOnClickOutside } from '@hooks/index';

const EnvIndicator = () => {
    const showInfoBlock = useBoolean(false);
    const infoBlockRef = useRef<HTMLDivElement | null>(null);
    const infoIconRef = useRef<HTMLDivElement | null>(null);
    const { environment, lockedEnvironment } = window;

    useOnClickOutside(infoBlockRef, () => showInfoBlock.setFalse(), [infoIconRef]);

    return (
        <div className={cn('k-d-flex k-align-items-center k-w-full', styles.envWrapper)} style={{ columnGap: '10px' }}>
            <FontAwesomeIcon icon={['far', 'server']} className="fa-xl k-color-white" />
            <div className={cn(styles.wrapperIndicator)}>
                <div
                    className={cn(
                        'k-d-flex k-w-full k-align-items-center k-justify-content-between k-px-3 k-rounded-md k-font-bold',
                        styles.envIndicator,
                        { [styles.envIndicatorDefault]: !lockedEnvironment as boolean | undefined },
                    )}
                >
                    <div className={styles.envName}>{environment}</div>
                    <div ref={infoIconRef}>
                        <FontAwesomeIcon
                            onClick={() => showInfoBlock.toggle()}
                            className={cn('k-cursor-pointer', 'k-rotate-180', styles.infoIcon)}
                            fontSize={16}
                            icon={['fal', 'circle-exclamation']}
                        />
                    </div>
                </div>
                {showInfoBlock.value && (
                    <EnvIndicatorList ref={infoBlockRef} environment={environment as string | undefined} />
                )}
            </div>
        </div>
    );
};

export default EnvIndicator;
